/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { Node } from '../../core/models/Node';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { IVisitor } from '../../core/visitors/IVisitor';
import { Document } from '../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends ServerVariable
 * @author eric.wittmann@gmail.com
 */
export abstract class AaiServerVariable extends ServerVariable {
    public examples : Array<string>;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(name);
            if(this.examples===undefined) this.examples = null;
            if(this.examples===undefined) this.examples = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
            if(this.examples===undefined) this.examples = null;
            if(this.examples===undefined) this.examples = null;
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            {
                let __args = arguments;
                let name : any = null;
                super(name);
                if(this.examples===undefined) this.examples = null;
                if(this.examples===undefined) this.examples = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IAaiVisitor = <IAaiVisitor><any>visitor;
        viz.visitServerVariable(this);
    }
}
AaiServerVariable["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiServerVariable";
AaiServerVariable["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




